import api from "@/plugins/axios";

export const getAll = async () => {
  const response = await api.get("/empresa");
  return response.data;
};

export const getById = async (id) => {
  const response = await api.get(`/empresa/${id}`);
  return response.data;
};

export const create = async (data) => {
  const response = await api.post("/empresa", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await api.put(`/empresa/${id}`, data);
  return response.data;
};

export const remove = async (id) => {
  await api.delete(`/empresa/${id}`);
};

export const getEmpresasComun = async (id) => {
  const response = await api.get(`/empresa/mismo-evento/${id}`);
  return response.data;
};
